import { useMutation, useQueryClient } from '@tanstack/react-query';
import { disconnectPayPal, disconnectStripe, updateInstantPayout } from '@/lib/api/payments';
import { QUERY_KEYS } from '@/lib/constants';

export const useDisconnectStripeMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: disconnectStripe,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INTEGRATIONS] });
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.STRIPE_CONNECT_STATUS] });
        },
    });
};

export const useDisconnectPayPalMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (integrationId: number) => disconnectPayPal(integrationId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.INTEGRATIONS] });
        },
    });
};

export const useInstantPayoutMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (enabled: boolean) => updateInstantPayout(enabled),
        onSuccess: () => {
            // Invalidate user query to refresh instant_payout preference
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
            // Invalidate stripe connect status
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.STRIPE_CONNECT_STATUS] });
        },
    });
};
